import React from "react"
import { Col } from "react-bootstrap"

function FormLabel({ text }) {
  return (
    <Col xs={12} md={6} className="textforinput marginTop10px">
      <p>{text}</p>
    </Col>
  )
}
export default FormLabel
